import React, { useContext, useEffect, useState } from "react";
// import './Integration.css';
import styled from "styled-components";
import { Link } from "react-router-dom";
import MaterialIcon from 'material-icons-react';

export function AdminSwitcher({active='integration', cardId}) {
  return (
  <CssAdminSwitcher0>
    <CssAdminSwitcher00>

        <CssAdminSwitch
          to={`/cms`} >
            <CssBack>
              <MaterialIcon color='currentColor' icon='chevron_left'/>
            </CssBack>
        </CssAdminSwitch>

        <CssAdminSwitch
          active={active === 'integration' ? true : false}
          to={`/card/${cardId}`} >
            Integration
        </CssAdminSwitch>

        <CssAdminSwitch
        active={active === 'email' ? true : false}
        to={`/card-email/${cardId}`} >
            Card Email
        </CssAdminSwitch>

        <CssAdminSwitch
        active={active === 'opepager' ? true : false}
        to={`/card-onepager/${cardId}`} >
            One Pager
        </CssAdminSwitch>

        <CssAdminSwitch
        active={active === 'landing' ? true : false}
        to={`/card-landing/${cardId}`} >
            Landing Page
        </CssAdminSwitch>

      </CssAdminSwitcher00>
    </CssAdminSwitcher0>)
}


const CssAdminSwitcher0 = styled.div`
  position: fixed;
  z-index: 100000000000;
  display: flex;
  top: 8px;
  width: 100%;
  justify-content: center;
`

const CssAdminSwitcher00 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #c5d0db;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px -2px rgba(0, 0, 0, 0.24);
`
const CssAdminSwitch = styled(Link)`
  justify-content: center;
  color: currentColor;
  text-decoration: none;
  padding: 8px 16px;
  background: ${({active}) => active ? 'white' : 'transparent'};
`
const CssBack = styled.div`
  margin: -5px -5px -8px -5px;
`